import React from "react";
import styles from "./SkillsComponent.module.css";
import { FaSalesforce, FaReact, FaNodeJs, FaGitAlt, FaDocker, FaAws } from "react-icons/fa";
import { SiJavascript, SiPostgresql, SiMongodb, SiTypescript, SiGitlab, SiJest, SiNextdotjs, SiGraphql, SiKubernetes, SiHtml5, SiCss3, SiRedis } from "react-icons/si";

const SkillsComponent = () => {
  const skills = [
    {
      title: "CRM & Salesforce Automation",
      description:
        "Still juggling customer info in spreadsheets? I design custom Salesforce solutions that automate follow-ups, track leads, and keep your sales pipeline organized—so nothing falls through the cracks.",
    },
    {
      title: "Business Process Automation",
      description:
        "If you're still doing it manually, you're wasting time. I build smart workflows that handle the repetitive stuff—quoting, reminders, status updates—so you and your team can focus on what actually matters.",
    },
    {
      title: "Revenue-Driving Websites",
      description:
        "Your website should work as hard as you do. I create high-performance, mobile-ready sites with booking tools, payment integration, and lead capture built-in—because pretty isn’t enough. Performance sells.",
    },
    {
      title: "Systems That Talk to Each Other",
      description:
        "Is your software a mess of disconnected tools? I integrate your CRM, POS, scheduling, and payment systems into one seamless experience—so your business flows and your data stays accurate.",
    },
  ];

  const tools = [
    { name: "Salesforce", icon: <FaSalesforce /> },
    { name: "React", icon: <FaReact /> },
    { name: "JavaScript", icon: <SiJavascript /> },
    { name: "Node.js", icon: <FaNodeJs /> },
    { name: "PostgreSQL", icon: <SiPostgresql /> },
    { name: "Git", icon: <FaGitAlt /> },
    { name: "Docker", icon: <FaDocker /> },
    { name: "AWS", icon: <FaAws /> },
    { name: "MongoDB", icon: <SiMongodb /> },
    { name: "TypeScript", icon: <SiTypescript /> },
    { name: "GitLab", icon: <SiGitlab /> },
    { name: "Jest", icon: <SiJest /> },
    { name: "Next.js", icon: <SiNextdotjs /> },
    { name: "GraphQL", icon: <SiGraphql /> },
    { name: "Kubernetes", icon: <SiKubernetes /> },
    { name: "HTML5", icon: <SiHtml5 /> },
    { name: "CSS3", icon: <SiCss3 /> },
    { name: "Redis", icon: <SiRedis /> },
  ];

  return (
    <section className={styles.skills}>
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>Systems That Grow With Your Business</h2>
        <p className={styles.sectionSubtitle}>
          We don’t just write code — we create solutions. Whether you need better lead tracking, faster workflows, or a website that actually converts, we’ll help you build systems that scale and sell.
        </p>
        <div className={styles.skillsGrid}>
          {skills.map((skill, index) => (
            <div className={styles.skillCard} key={index}>
              <h3 className={styles.skillTitle}>{skill.title}</h3>
              <p className={styles.skillDescription}>{skill.description}</p>
            </div>
          ))}
        </div>

        <h3 className={styles.toolsTitle}>Tech Stack You Can Trust</h3>
        <div className={styles.toolsIcons}>
          {tools.map((tool, index) => (
            <div className={styles.toolIcon} key={index}>
              {tool.icon}
              <span className={styles.toolName}>{tool.name}</span>
            </div>
          ))}
        </div>

        <div className={styles.cta}>
          <a href="/contact" className={`${styles.btn} ${styles.primaryBtn}`}>
            Claim Your Free Business Systems Audit
          </a>
        </div>
      </div>
    </section>
  );
};

export default SkillsComponent;
